export default __webpack_public_path__ + "static/media/weather.44d4506b.jpg";